import React from 'react';
import { Navbar } from './Navbar/Navbar';
import logo from '../../images/ConsultVision_logo.svg';
import './header.scss';

export const Header = (props) => {
  return (
    <div className="header">
      <div className="logo_div">
        <img src={logo} alt="company logo" className="logo" />
      </div>
      <Navbar showLPLinks={props.showLPLinks} />
    </div>
  );
};
